var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import { Curriculum } from '@/models/Curriculum';
import AreaRow from '@/components/area-row/AreaRow';
import SelectFilter from '@/components/select-filter/SelectFilter';
import ErrorHandler from '@/support/ErrorHandler';
let AddSubjectDialog = class AddSubjectDialog extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.filters = {
            periods: [],
            levels: [],
        };
        this.currentStep = 1;
        this.areas = [];
        this.isLoading = true;
        this.curriculum = new Curriculum();
        this.selectedSubjects = [];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.selectedSubjects = [...this.selectedSubjects, ...this.existingSubjects];
        this.setSelectedSubjects(this.selectedSubjects);
        this.initialize();
    }
    onSetSelectedSubjects(subjects) {
        this.selectedSubjects = [...subjects, ...this.existingSubjects];
        this.setSelectedSubjects(this.selectedSubjects);
    }
    setSelectedSubjects(subjects) {
        this.$store.dispatch('selectedChanged', subjects);
    }
    async initialize() {
        this.isLoading = true;
        this.areas = [];
        // this.selectedSubjects = [];
        // this.$store.state.selected = [];
        try {
            const curriculum = await new Curriculum()
                .current()
                .first();
            this.curriculum = curriculum;
            if (curriculum.id) {
                this.getSubjects();
            }
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Class methods
    close() {
        this.clear();
        this.$emit('input', false);
        this.currentStep = 1;
    }
    clear() {
        this.selectedSubjects = [];
        this.$store.state.selected = [];
        this.$store.dispatch('checkboxReset', true);
    }
    filterCurriculum() {
        this.selectedSubjects = this.$store.state.selected;
        this.selectedSubjects.forEach((selectedSubject) => {
            if (!selectedSubject.parent) {
                return;
            }
            this.$store.state.curriculum.subjects.forEach((area) => {
                if (!area.children) {
                    return;
                }
                const topics = area.children.filter((subject) => {
                    return subject.id === selectedSubject.parent.id;
                });
                if (topics.length) {
                    selectedSubject.parent.parent = area;
                }
            });
        });
    }
    create() {
        this.$emit('update', this.selectedSubjects);
    }
    deleteSelectedSubject(index) {
        this.selectedSubjects.splice(index, 1);
    }
    // #endregion
    // #region Async methods
    async getSubjects(extendedFilters = {}) {
        this.isLoading = true;
        extendedFilters.curriculum = this.curriculum.id;
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null || this.filters[key].length === 0) {
                return;
            }
            extendedFilters[key] = this.filters[key];
        });
        try {
            const subjects = await new Subject()
                .filter(extendedFilters)
                .include('children')
                .all();
            this.areas = subjects;
            this.curriculum.subjects = subjects;
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        this.isLoading = false;
    }
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    levelFilterChange() {
        if (this.curriculum.id) {
            this.getSubjects();
        }
    }
    currentStepChanged() {
        if (this.currentStep === 2) {
            this.filterCurriculum();
        }
        if (this.currentStep === 3) {
            this.create();
        }
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], AddSubjectDialog.prototype, "existingSubjects", void 0);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddSubjectDialog.prototype, "levelFilterChange", null);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddSubjectDialog.prototype, "currentStepChanged", null);
AddSubjectDialog = __decorate([
    Component({
        components: {
            AreaRow,
            SelectFilter,
        },
    })
], AddSubjectDialog);
export default AddSubjectDialog;
